<template>
    <div>
        <v-container fluid>
            <v-row class="p-3">
                <v-col
                        v-for="(image,index) in img"
                        :key="image.id"
                        cols="12"
                        class="p-0 mx-auto"
                        md="2"
                        :data-img="image.id"
                >
                    <v-radio-group v-model="selectedImage">
                        <v-radio
                                color="indigo"
                                :value="image.value"
                        ></v-radio>
                    </v-radio-group>
                    <v-img
                            :src="$route.name==='headerForm.index'?image.headerPath :image.full_path "
                            :lazy-src="$route.name==='headerForm.index'?image.headerPath :image.full_path"
                            aspect-ratio="1"
                            :key="image.id"
                    >
                    </v-img>
                    <p class="text-center mr-5">{{ image.name }}</p>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
    name: "complicative/newType",
    data() {
        return {
            selectedImage: [],
            img: [
                {
                    id: '1',
                    name: 'پیچیده',
                    value: 'complicative',
                    full_path: require('../../../../public/media/site/complicative/new/پیچیده.png'),
                    headerPath:require('../../../../public/media/site/complicative/header/پیچیده.png')
                },
                {
                    id: '2',
                    name: 'طبیعی',
                    value: 'natural',
                    full_path: require('../../../../public/media/site/complicative/new/طبیعی.png'),
                    headerPath:require('../../../../public/media/site/complicative/header/طبیعی.png')
                },
                {
                    id: '3',
                    name: 'گوشه تیز',
                    value: 'sharpCorner',
                    full_path: require('../../../../public/media/site/complicative/new/گوشه تیز.png'),
                    headerPath: require('../../../../public/media/site/complicative/header/گوشه-تیز.png')
                },
                {
                    id: '4',
                    name: 'انتزاعی',
                    value: 'abstract',
                    full_path: require('../../../../public/media/site/complicative/new/انتزاعی.png'),
                    headerPath: require('../../../../public/media/site/complicative/header/انتزاعی.png')
                },
                {
                    id: '4',
                    name: 'به انتخاب طراح',
                    value: 'designerChose',
                    full_path: require('../../../../public/media/site/complicative/new/به-انتخاب-طراح.jpg'),
                    headerPath: require('../../../../public/media/site/complicative/header/به-انتخاب-طراح.jpg')
                },
            ],
            count: 1,
        }
    },
    watch:{
        selectedImage() {
            this.$emit('persianName',this.img.find((x)=>x.value === this.selectedImage).name,"complex")
            this.$emit('input', this.selectedImage)
        }
    }
}
</script>

<style scoped>

</style>